export default __webpack_public_path__ + "static/media/y_wdt_c_6.56bb65d3.mp3";